import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import AppButton from "../button/AppButton";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { hideMessage } from "../../store/slices/appMessageSlice";

const AppMessageModal = () => {
  const dispatch = useAppDispatch();
  const { open, title, message, type } = useAppSelector(
    (state) => state.appMessage,
  );

  return (
    <Dialog
      open={open}
      onClose={() => dispatch(hideMessage())}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Alert severity={type}>{message}</Alert>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <AppButton onClick={() => dispatch(hideMessage())}>OK</AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default AppMessageModal;
